"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2624],{

/***/ 23508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoRelatedLinkList_SeoRelatedLinkList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/List/index.js + 10 modules
var List = __webpack_require__(78012);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/SeoRelatedLinkList.styles.js

var _templateObject, _templateObject2;


var SeoRelatedLinkList_styles_List = (0,styled_components_browser_esm["default"])(List/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  > li {\n    padding: 0 8px !important;\n  }\n  > li > a {\n    padding: 0 !important;\n  }\n  > li > a:hover {\n    text-decoration: underline;\n  }\n"])));
var ListContainer = (0,styled_components_browser_esm["default"])(List/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  margin: 0 auto;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/SeoRelatedLinkList.js





var SeoRelatedLinkList = function SeoRelatedLinkList(_ref) {
  var _data$seoRelatedLink, _data$seoRelatedLink2;
  var data = _ref.data,
    titleText = _ref["static"].titleText;
  var onLinkClick = function onLinkClick(e, href) {
    e.preventDefault();
    (0,esm/* routePush */.dY)({
      path: href,
      spa: true
    });
  };
  return ((_data$seoRelatedLink = data.seoRelatedLink) == null ? void 0 : _data$seoRelatedLink.length) > 0 ? react.createElement(ListContainer, null, titleText && react.createElement(SeoRelatedLinkList_styles_List.Header, {
    "data-testid": "link-list-header",
    p: " 0 8px !important"
  }, titleText), react.createElement(SeoRelatedLinkList_styles_List, {
    "data-testid": "link-list"
  }, (_data$seoRelatedLink2 = data.seoRelatedLink) == null ? void 0 : _data$seoRelatedLink2.map(function (_ref2) {
    var label = _ref2.label,
      href = _ref2.href;
    return react.createElement(SeoRelatedLinkList_styles_List.Item, {
      as: "a",
      scale: "small",
      key: 1,
      href: href,
      onClick: function onClick(e) {
        return onLinkClick(e, href);
      }
    }, label);
  }))) : null;
};
 false ? 0 : void 0;
SeoRelatedLinkList.defaultProps = {
  data: {},
  "static": {}
};
SeoRelatedLinkList.ssr = true;
/* harmony default export */ var SeoRelatedLinkList_SeoRelatedLinkList = ((0,withLayoutProps/* default */.Z)(SeoRelatedLinkList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoRelatedLinkList/index.js


/***/ }),

/***/ 408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SeoSubcategoryList_SeoSubcategoryList; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Link/index.js + 2 modules
var Link = __webpack_require__(10200);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoSubcategoryList/SeoSubcategoryList.styles.js

var _templateObject;

var Container = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  column-count: ", ";\n  min-height: 250px;\n"])), function (_ref) {
  var columns = _ref.columns;
  return columns;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoSubcategoryList/SeoSubcategoryList.js






var SeoSubcategoryList = function SeoSubcategoryList(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var subcategories = data == null ? void 0 : data.seoDepartmentSubCategories.data;
  var basePath = structure.basePath;
  var onSubcategoryClick = function onSubcategoryClick(truePath) {
    (0,esm/* routePush */.dY)({
      path: "".concat(basePath).concat(truePath),
      spa: true
    });
  };
  return react.createElement(Container, {
    "data-testid": "ctn-subcategories",
    columns: staticProps.columns
  }, subcategories.map(function (item) {
    var _item$meta2;
    return react.createElement(Link/* default */.Z, {
      onClick: function onClick(e) {
        var _item$meta;
        e.preventDefault();
        onSubcategoryClick(item == null ? void 0 : (_item$meta = item.meta) == null ? void 0 : _item$meta.truePath);
      },
      key: item == null ? void 0 : item.id,
      href: "".concat(basePath).concat((item == null ? void 0 : (_item$meta2 = item.meta) == null ? void 0 : _item$meta2.truePath) || ''),
      my: 2,
      as: "a",
      color: "text.primary",
      display: "block",
      style: {
        wordBreak: 'break-all'
      }
    }, item == null ? void 0 : item.h1);
  }));
};
SeoSubcategoryList.ssr = true;
 false ? 0 : void 0;
SeoSubcategoryList.defaultProps = {
  data: {
    seoDepartmentSubCategories: {
      data: []
    }
  },
  "static": {
    columns: 4
  },
  structure: {
    basePath: ''
  }
};
SeoSubcategoryList.dataSource = {
  seoDepartmentSubCategories: {
    query: 'seoDepartmentSubCategoriesQuery'
  }
};
/* harmony default export */ var SeoSubcategoryList_SeoSubcategoryList = ((0,withLayoutProps/* default */.Z)(SeoSubcategoryList));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/SeoSubcategoryList/index.js


/***/ }),

/***/ 98339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesActionButtons_ServicesActionButtons; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/index.js + 2 modules
var ServicesAuthorizationTerm = __webpack_require__(73604);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/ServicesActionButtons.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4;





var ActionButtonsWrapper = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: sticky;\n  bottom: 0px;\n  background-color: white;\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,esm.getMediaQuery)('medium'));
var ServicesActionButtons_styles_Button = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 12px;\n  font-size: 16px;\n  height: 48px;\n  width: 100%;\n  margin: 0 5px;\n"])));
var ButtonsWrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return {
    props: props
  };
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 50%;\n  ", " {\n    justify-content: end;\n    flex: 3;\n    order: 3;\n  }\n"])), (0,esm.getMediaQuery)('medium'));
var Wrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return {
    props: props
  };
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: 22px;\n  padding: 25px 20px;\n  width: 100%;\n  flex-wrap: wrap;\n  ", " {\n    flex-direction: row;\n    justify-content: end;\n  }\n"])), (0,esm.getMediaQuery)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/ServicesActionButtons.js




var ServicesActionButtons = function ServicesActionButtons(_ref) {
  var authorizationTermText = _ref.authorizationTermText,
    handleAcquireServices = _ref.handleAcquireServices,
    hasCancelButton = _ref.hasCancelButton,
    titleCancelButton = _ref.titleCancelButton;
  return react.createElement(ActionButtonsWrapper, null, react.createElement(Wrapper, {
    "data-testid": "buttons-wrapper"
  }, react.createElement(ServicesAuthorizationTerm/* default */.Z, {
    authorizationTermText: authorizationTermText
  }), hasCancelButton && react.createElement(ButtonsWrapper, null, react.createElement(ServicesActionButtons_styles_Button, {
    color: "secondary",
    variation: "outline",
    uppercase: false,
    onClick: handleAcquireServices.continueWithoutServices,
    "data-testid": "no-services"
  }, titleCancelButton)), react.createElement(ButtonsWrapper, null, react.createElement(ServicesActionButtons_styles_Button, {
    disabled: handleAcquireServices.disableContinueAddingServices,
    "aria-disabled": handleAcquireServices.disableContinueAddingServices,
    color: "secondary",
    uppercase: false,
    onClick: handleAcquireServices.continueAddingServices,
    "data-testid": "acquire-services"
  }, "Incluir Prote\xE7\xE3o"))));
};
ServicesActionButtons.defaultProps = {
  authorizationTermText: 'Termos de autorização',
  hasCancelButton: false,
  titleCancelButton: 'Agora não'
};
 false ? 0 : void 0;
ServicesActionButtons.ssr = true;
/* harmony default export */ var ServicesActionButtons_ServicesActionButtons = ((0,react.memo)(ServicesActionButtons));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesActionButtons/index.js


/***/ }),

/***/ 73604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesAuthorizationTerm_ServicesAuthorizationTerm; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/ServicesAuthorizationTerm.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;





var ClickableText = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n  text-decoration: underline;\n"])));
var DialogContainer = (0,styled_components_browser_esm["default"])(Dialog/* default */.Z)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-height: 80vh;\n  padding: ", "px ", "px;\n  ", " {\n    width: 85%;\n    padding: ", "px;\n  }\n"])), (0,esm.themeGet)('space.3'), (0,esm.themeGet)('space.2'), (0,esm.getMediaQuery)('medium'), (0,esm.themeGet)('space.3'));
var DialogContent = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n"])), function (props) {
  return (0,esm.themeGet)('lineHeights.display')(props);
});
var MainText = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  text-align: center;\n  margin-top: 24px;\n  ", " {\n    max-width: 358px;\n    text-align: right;\n    margin-top: 0px;\n  }\n"])), (0,esm.themeGet)('fontSizes.2'), (0,esm.getMediaQuery)('medium'));
var Wrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  order: 3;\n  justify-content: center;\n  ", " {\n    flex: 6;\n    order: 1;\n  }\n"])), (0,esm.getMediaQuery)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/ServicesAuthorizationTerm.js




var ServicesAuthorizationTerm = function ServicesAuthorizationTerm(_ref) {
  var authorizationTermText = _ref.authorizationTermText;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    showingTac = _useState2[0],
    setShowingTac = _useState2[1];
  return react.createElement(react.Fragment, null, react.createElement(Wrapper, null, react.createElement(MainText, {
    textAlign: "center"
  }, "Ao clicar em", react.createElement("strong", null, ' "Incluir proteção" '), "voc\xEA concorda com os \xA0", react.createElement(ClickableText, {
    as: "span",
    "data-testid": "auth-term-label",
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return setShowingTac(true);
    }
  }, react.createElement("strong", null, "Termos de autoriza\xE7\xE3o de cobran\xE7a")))), react.createElement(DialogContainer, {
    "data-testid": "auth-term-dialog",
    onClickOutside: function onClickOutside() {
      return setShowingTac(false);
    },
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: showingTac,
    showClose: true
  }, react.createElement(DialogContent, {
    dangerouslySetInnerHTML: {
      __html: authorizationTermText
    }
  })));
};
ServicesAuthorizationTerm.defaultProps = {
  authorizationTermText: 'Termos de autorização'
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesAuthorizationTerm_ServicesAuthorizationTerm = (ServicesAuthorizationTerm);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesAuthorizationTerm/index.js


/***/ }),

/***/ 69913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesCard_ServicesCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/index.js + 2 modules
var ServicesOfferPriceAndInstallments = __webpack_require__(60015);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServicesCard.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;






var ServicesCard_styles_Checkbox = (0,styled_components_browser_esm["default"])(Checkbox/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  input {\n    min-width: 20px;\n  }\n"])));
var ServicesCard_styles_HorizontalRule = (0,styled_components_browser_esm["default"])(HorizontalRule/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 12px 4px 0px;\n  width: 100%;\n\n  ", " {\n    margin: 16px 4px 0px;\n    width: auto;\n  }\n"])), (0,esm.getMediaQuery)('medium'));
var RecommendedContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-end',
    flexDirection: 'column'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: 12px;\n  padding-right: 16px;\n  visibility: ", ";\n"])), function (props) {
  return (props == null ? void 0 : props.recommended) ? 'visible' : 'hidden';
});
var RecommendedText = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    backgroundColor: 'primary.base',
    color: 'white'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border-radius: 7px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 2px 6px;\n"])));
var Wrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    borderRadius: 8,
    color: 'greyishBrown',
    flexDirection: 'column'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)([""])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServiceCheckbox.js







var ServiceCheckbox = function ServiceCheckbox(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange,
    offerId = _ref.offerId,
    title = _ref.title,
    selectedOfferPrice = _ref.selectedOfferPrice;
  var handleChange = function handleChange(event) {
    onChange(event.target.checked ? offerId : null);
  };
  return react.createElement(Box/* default */.Z, {
    pl: 3,
    pr: 3
  }, react.createElement(ServicesCard_styles_Checkbox, {
    checked: checked,
    onChange: handleChange
  }, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    fontSize: 2
  }, title)), react.createElement(Flex/* default */.Z, {
    justifyContent: "space-between",
    alignItems: "left",
    marginTop: "20px"
  }, react.createElement(ServicesOfferPriceAndInstallments/* default */.Z, selectedOfferPrice)));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesCard_ServiceCheckbox = (ServiceCheckbox);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/ServicesCard.js




var ServicesCard = function ServicesCard(props) {
  var title = props.title,
    checked = props.checked,
    onChange = props.onChange,
    value = props.value,
    recommended = props.recommended,
    selectedOfferPrice = props.selectedOfferPrice;
  return react.createElement(Wrapper, {
    "data-testid": "service-card"
  }, react.createElement(RecommendedContainer, {
    recommended: recommended,
    "data-testid": "recommended-container"
  }, react.createElement(RecommendedText, null, "Recomendado")), react.createElement(ServicesCard_ServiceCheckbox, {
    checked: checked,
    onChange: onChange,
    title: title,
    offerId: value,
    selectedOfferPrice: selectedOfferPrice
  }), react.createElement(ServicesCard_styles_HorizontalRule, {
    size: 2
  }));
};
ServicesCard.defaultProps = {
  selectedOfferPrice: {}
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesCard_ServicesCard = (ServicesCard);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/index.js


/***/ }),

/***/ 28946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesGroup_ServicesGroup; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Collapse/index.js + 2 modules
var Collapse = __webpack_require__(88699);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesCard/index.js + 3 modules
var ServicesCard = __webpack_require__(69913);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/index.js + 5 modules
var ServicesInfo = __webpack_require__(80496);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/ServicesGroup.styles.js


var _templateObject, _templateObject2, _templateObject3;




var ArrowIcon = (0,styled_components_browser_esm["default"])(esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var ExtraInfoFlex = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var Wrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    bg: 'background.white',
    flexDirection: 'column',
    mb: 2,
    pb: 3
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  height: fit-content;\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,build_esm.getMediaQuery)('medium'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/utils.js
var findCheckedIndex = function findCheckedIndex(options) {
  var selected = options.findIndex(function (option) {
    return option.checked;
  });
  return selected !== -1 ? selected : options.findIndex(function (option) {
    return option.recommended;
  });
};
var findMaxIndexCheckedOrRecomended = function findMaxIndexCheckedOrRecomended(options) {
  var checkedIndex = options.findIndex(function (option) {
    return option.checked;
  });
  var recommendedIndex = options.findIndex(function (option) {
    return option.recommended;
  });
  return Math.max(checkedIndex, recommendedIndex);
};
var optionsHideCardsCollapsed = function optionsHideCardsCollapsed(isOpen, selectedIndex, options) {
  if (!isOpen) {
    return selectedIndex !== -1 ? [options[selectedIndex]] : [options[0]];
  }
  return options;
};
var optionsShowCardsCollapsed = function optionsShowCardsCollapsed(isOpen, selectedIndex, options, serviceKey, visibleCards) {
  if (visibleCards[serviceKey]) {
    var valuesToShow = selectedIndex > 0 ? selectedIndex + 1 : visibleCards[serviceKey];
    return options == null ? void 0 : options.filter(function (option, index) {
      return index < valuesToShow || isOpen || option.checked;
    });
  }
  return options;
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/ServicesGroup.js












var ServiceIds = {
  GARANTIA_ESTENDIDA: 5,
  ROUBO_E_FURTO: 3,
  TROCA_CERTA: 4
};
var ServicesGroup = function ServicesGroup(props) {
  var _service$period2;
  var service = props.service;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var extraInfo = service.extraInfo;
  var onInfoClick = extraInfo.onInfoClick,
    _extraInfo$serviceGro = extraInfo.serviceGroupLayoutConfig,
    serviceGroupLayoutConfig = _extraInfo$serviceGro === void 0 ? {
      showCardsCollapsed: true,
      visibleCards: (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, ServiceIds.ROUBO_E_FURTO, 2), ServiceIds.TROCA_CERTA, 2), ServiceIds.GARANTIA_ESTENDIDA, 1)
    } : _extraInfo$serviceGro;
  var showCardsCollapsed = serviceGroupLayoutConfig.showCardsCollapsed,
    visibleCards = serviceGroupLayoutConfig.visibleCards;
  var handleInfoClick = function handleInfoClick() {
    setIsOpen(!isOpen);
    onInfoClick(!isOpen);
  };
  var memorizedSelectedIndex = (0,react.useMemo)(function () {
    var _service$period;
    var options = service == null ? void 0 : (_service$period = service.period) == null ? void 0 : _service$period.options;
    return showCardsCollapsed ? findMaxIndexCheckedOrRecomended(options) : findCheckedIndex(options);
  }, [isOpen, service]);
  var renderShowCardsCollapsed = function renderShowCardsCollapsed(options, serviceKey) {
    var _optionsShowCardsColl;
    return (_optionsShowCardsColl = optionsShowCardsCollapsed(isOpen, memorizedSelectedIndex, options, serviceKey, visibleCards)) == null ? void 0 : _optionsShowCardsColl.map(function (option) {
      return react.createElement(ServicesCard/* default */.Z, (0,esm_extends/* default */.Z)({
        key: "period-".concat(option == null ? void 0 : option.value)
      }, option));
    });
  };
  var renderHideCardsCollapsed = function renderHideCardsCollapsed(options) {
    var _optionsHideCardsColl;
    return (_optionsHideCardsColl = optionsHideCardsCollapsed(isOpen, memorizedSelectedIndex, options)) == null ? void 0 : _optionsHideCardsColl.map(function (option) {
      return react.createElement(ServicesCard/* default */.Z, (0,esm_extends/* default */.Z)({
        key: "period-".concat(option == null ? void 0 : option.value)
      }, option));
    });
  };
  var renderGroupServicesCard = function renderGroupServicesCard(options, serviceKey) {
    if (showCardsCollapsed) {
      return renderShowCardsCollapsed(options, serviceKey);
    }
    return renderHideCardsCollapsed(options);
  };
  return react.createElement(Wrapper, {
    key: service == null ? void 0 : service.key,
    "data-testid": "service-group"
  }, renderGroupServicesCard(service == null ? void 0 : (_service$period2 = service.period) == null ? void 0 : _service$period2.options, service.key), extraInfo && Object.keys(extraInfo).length > 0 && react.createElement(Box/* default */.Z, null, react.createElement(Collapse/* default */.Z, {
    trigger: !isOpen
  }, react.createElement(ServicesInfo/* default */.Z, extraInfo)), react.createElement(ExtraInfoFlex, {
    alignItems: "center",
    onClick: handleInfoClick,
    pt: 3,
    pl: 3,
    pr: 3
  }, react.createElement(Text/* default */.Z, {
    as: "span",
    fontSize: 1,
    "data-testid": "open-service-info"
  }, "Ver mais"), react.createElement(ArrowIcon, {
    name: "Chevron".concat(isOpen ? 'Up' : 'Down')
  }))));
};
ServicesGroup.defaultProps = {
  service: {}
};
var benefitPropType =  false ? 0 : {};
var extraInfoPropType =  false ? 0 : {};
var serviceGroupLayoutConfigPropTypes =  false ? 0 : {};
var selectedOfferPricePropType =  false ? 0 : {};
var periodOptionPropType =  false ? 0 : {};
var periodPropType =  false ? 0 : {};
var servicePropType =  false ? 0 : {};
 false ? 0 : void 0;
/* harmony default export */ var ServicesGroup_ServicesGroup = ((0,react.memo)(ServicesGroup));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/index.js


/***/ }),

/***/ 80496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesInfo_ServicesInfo; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/HorizontalRule/index.js + 2 modules
var HorizontalRule = __webpack_require__(97600);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/ServicesInfo.styles.js


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;







var AgreementContent = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  line-height: ", ";\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('lineHeights.display')(props);
});
var AgreementLabel = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    fontSize: 13,
    lineHeight: '16px',
    paddingLeft: '16px',
    width: '144px'
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var ArrowIcon = (0,styled_components_browser_esm["default"])(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    position: 'relative'
  }, props);
})(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  cursor: pointer;\n"])));
var BenefitContainer = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'flex-start',
    flexDirection: 'column',
    gap: 10,
    textAlign: 'left'
  }, props);
})(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var BenefitPriceText = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '20px',
    p: 2,
    width: '100%'
  }, props);
})(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 16px;\n  background-color: #f1ffe7;\n  font-weight: 500;\n"])));
var BenefitText = (0,styled_components_browser_esm["default"])(Text/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    lineHeight: '20px',
    pl: 2,
    pr: 2
  }, props);
})(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: 14px;\n"])));
var DialogContainer = (0,styled_components_browser_esm["default"])(Dialog/* default */.Z)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  max-height: 80vh;\n  padding: ", "px ", "px;\n  ", " {\n    width: 85%;\n    padding: ", "px;\n  }\n"])), (0,stereo_ui_styles_build_esm.themeGet)('space.3'), (0,stereo_ui_styles_build_esm.themeGet)('space.2'), (0,stereo_ui_styles_build_esm.getMediaQuery)('medium'), (0,stereo_ui_styles_build_esm.themeGet)('space.3'));
var IconCheck = (0,styled_components_browser_esm["default"])(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#429502',
    height: 25,
    marginRight: 9,
    minHeight: 25,
    minWidth: 25,
    width: 25
  }, props);
})(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var IconPrize = (0,styled_components_browser_esm["default"])(build_esm/* Icon */.JO$).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    color: '#429502',
    height: 40,
    marginRight: 9,
    minHeight: 40,
    minWidth: 40,
    paddingLeft: 9,
    width: 40
  }, props);
})(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)([""])));
var RuleWithMargin = (0,styled_components_browser_esm["default"])(HorizontalRule/* default */.Z)(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: '16px 0';\n  width: '100%';\n"])));
var VideoContent = styled_components_browser_esm["default"].div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  overflow: hidden;\n  padding: 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-height: 260px;\n\n  &::after {\n    padding-top: 56.25%;\n    display: block;\n    content: '';\n  }\n\n  > iframe {\n    width: 100%;\n    height: 255px;\n  }\n"])));
var VideoWrapper = styled_components_browser_esm["default"].div(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n  margin: 0px 30px 8px 30px;\n  border-top: 1px solid #ccc;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/Benefits.js




var Benefits = function Benefits(_ref) {
  var benefit = _ref.benefit;
  var benefitLength = benefit == null ? void 0 : benefit.length;
  return react.createElement(react.Fragment, null, benefit == null ? void 0 : benefit.map(function (_ref2, index) {
    var description = _ref2.description,
      iconName = _ref2.iconName;
    var isLastItem = index + 1 < benefitLength;
    return isLastItem ? react.createElement(BenefitText, {
      key: (0,esm/* slug */.oF)(description + index),
      "data-testid": "benefit-container",
      pr: 2
    }, react.createElement(IconCheck, {
      name: iconName !== null && iconName !== void 0 ? iconName : 'Done',
      "data-testid": "benefit-icon"
    }), description) : react.createElement(BenefitPriceText, {
      key: (0,esm/* slug */.oF)(description + index),
      "data-testid": "benefit-container",
      pr: 3
    }, react.createElement(IconPrize, {
      name: iconName !== null && iconName !== void 0 ? iconName : 'Done',
      "data-testid": "benefit-icon"
    }), description);
  }));
};
Benefits.defaultProps = {
  benefit: [{
    description: '',
    iconName: ''
  }]
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesInfo_Benefits = (Benefits);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/Dialog.js




var Dialog_Dialog = function Dialog(props) {
  var agreementModalOpen = props.agreementModalOpen,
    agreementText = props.agreementText,
    handleClickEvent = props.handleClickEvent,
    open = props.open,
    videoModalOpen = props.videoModalOpen,
    videoUrl = props.videoUrl;
  return react.createElement(DialogContainer, {
    "data-testid": "dialog-container",
    onClickOutside: function onClickOutside() {
      return handleClickEvent(videoModalOpen ? 'video' : 'agreement');
    },
    bg: "background.white",
    position: "center",
    type: "dialog",
    visible: open,
    showClose: true,
    pl: 3,
    pr: 3
  }, agreementModalOpen && react.createElement(AgreementContent, {
    dangerouslySetInnerHTML: {
      __html: agreementText
    },
    "data-testid": "agreement-content"
  }), videoModalOpen && react.createElement(VideoContent, {
    pl: 3,
    pr: 3
  }, react.createElement("iframe", {
    src: (0,esm/* parseVideoUrl */.$4)(videoUrl),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    "data-testid": "video-content"
  })));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesInfo_Dialog = (Dialog_Dialog);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/useServicesInfo.js


var useServicesInfo = function useServicesInfo(props) {
  var benefit = props.benefit,
    title = props.title,
    agreementText = props.agreementText,
    label = props.label,
    labelBold = props.labelBold,
    videoUrl = props.videoUrl,
    onModalOpen = props.onModalOpen;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    agreementModalOpen = _useState4[0],
    setAgreementModalOpen = _useState4[1];
  var _useState5 = (0,react.useState)(false),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    videoModalOpen = _useState6[0],
    setVideoModalOpen = _useState6[1];
  var handleClickEvent = (0,react.useCallback)(function (modalType) {
    setOpen(!open);
    if (onModalOpen) onModalOpen({
      modalType: modalType,
      open: !open
    });
    if (modalType === 'agreement') {
      setAgreementModalOpen(!agreementModalOpen);
      setVideoModalOpen(false);
      return;
    }
    setVideoModalOpen(!videoModalOpen);
    setAgreementModalOpen(false);
  }, [agreementModalOpen, videoModalOpen]);
  return {
    agreement: {
      title: title
    },
    benefit: benefit,
    dialog: {
      agreementModalOpen: agreementModalOpen,
      agreementText: agreementText,
      open: open,
      videoModalOpen: videoModalOpen,
      videoUrl: videoUrl
    },
    handleClickEvent: handleClickEvent,
    video: {
      label: label,
      labelBold: labelBold
    }
  };
};
/* harmony default export */ var ServicesInfo_useServicesInfo = (useServicesInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/ServicesInfo.js










var ServicesInfo = function ServicesInfo(props) {
  var showVideo = props.showVideo,
    videoUrl = props.videoUrl;
  var _useServicesInfo = ServicesInfo_useServicesInfo(props),
    agreement = _useServicesInfo.agreement,
    benefit = _useServicesInfo.benefit,
    dialog = _useServicesInfo.dialog,
    handleClickEvent = _useServicesInfo.handleClickEvent,
    video = _useServicesInfo.video;
  return react.createElement(react.Fragment, null, react.createElement(BenefitContainer, {
    mb: 2,
    mt: 3
  }, react.createElement(ServicesInfo_Benefits, {
    benefit: benefit
  })), video.label && react.createElement(react.Fragment, null, react.createElement(RuleWithMargin, null), showVideo && react.createElement(VideoContent, null, react.createElement("iframe", {
    src: (0,esm/* parseVideoUrl */.$4)(videoUrl),
    title: "YouTube video player",
    frameBorder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    "data-testid": "video-content"
  }))), agreement.title && react.createElement(react.Fragment, null, react.createElement(RuleWithMargin, null), react.createElement(Flex/* default */.Z, {
    alignItems: "center",
    pr: 3
  }, react.createElement(AgreementLabel, {
    onClick: function onClick() {
      return handleClickEvent('agreement');
    },
    "data-testid": "agreement-trigger",
    mb: 3,
    mt: 3
  }, agreement.title), react.createElement(ArrowIcon, {
    name: "ChevronRight"
  }))), react.createElement(HorizontalRule/* default */.Z, null), react.createElement(ServicesInfo_Dialog, (0,esm_extends/* default */.Z)({
    handleClickEvent: handleClickEvent
  }, dialog)));
};
ServicesInfo.defaultProps = {
  agreementText: '',
  benefit: [{
    description: ''
  }],
  label: '',
  labelBold: '',
  showVideo: false,
  title: '',
  videoUrl: ''
};
 false ? 0 : void 0;
ServicesInfo.ssr = true;
/* harmony default export */ var ServicesInfo_ServicesInfo = (ServicesInfo);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesInfo/index.js


/***/ }),

/***/ 60015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesOfferPriceAndInstallments_ServicesOfferPriceAndInstallments; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/ServicesOfferPriceAndInstallments.styles.js

var _templateObject;


var StrikeText = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  text-decoration: line-through;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/ServicesOfferPriceAndInstallments.js





var ServicesOfferPriceAndInstallments = function ServicesOfferPriceAndInstallments(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    pretitle = _ref.pretitle;
  return react.createElement(Box/* default */.Z, {
    "data-testid": "price-installments-container"
  }, react.createElement(Text/* default */.Z, {
    color: "gray",
    textAlign: "left",
    fontSize: 1,
    "data-testid": "pretitle-text"
  }, pretitle && react.createElement(react.Fragment, null, 'de ', react.createElement(StrikeText, {
    color: "gray",
    as: "span"
  }, pretitle))), react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    textAlign: "left",
    fontSize: 2,
    "data-testid": "title-text",
    padding: "6px 0px"
  }, title.text, react.createElement(Text/* default */.Z, {
    fontWeight: "bold",
    as: "span"
  }, title.bold)), react.createElement(Text/* default */.Z, {
    color: "gray",
    textAlign: "left",
    fontWeight: "500",
    fontSize: 1,
    "data-testid": "subtitle-text"
  }, subtitle));
};
 false ? 0 : void 0;
ServicesOfferPriceAndInstallments.defaultProps = {
  pretitle: undefined
};
ServicesOfferPriceAndInstallments.ssr = true;
/* harmony default export */ var ServicesOfferPriceAndInstallments_ServicesOfferPriceAndInstallments = (ServicesOfferPriceAndInstallments);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesOfferPriceAndInstallments/index.js


/***/ }),

/***/ 77900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesProductCard_ServicesProductCard; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/ResponsiveImage/index.js + 2 modules
var ResponsiveImage = __webpack_require__(7029);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/ServicesProductCard.styles.js


var _templateObject, _templateObject2;




var Image = (0,styled_components_browser_esm["default"])(ResponsiveImage/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  max-width: 100%;\n  height: 79px;\n  width: 79px;\n"])));
var Wrapper = (0,styled_components_browser_esm["default"])(Flex/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({
    alignItems: 'center',
    bg: 'background.white',
    color: 'greyisBrown',
    mb: 2,
    mt: 2,
    p: 2
  }, props);
})(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  ", " {\n    border-radius: 8px;\n  }\n"])), (0,esm.getMediaQuery)('small'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/ServicesProductCard.js




var ServicesProductCard = function ServicesProductCard(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    title = _ref.title;
  return react.createElement(Wrapper, {
    "data-testid": "product-service"
  }, react.createElement(Image, {
    src: src,
    alt: alt
  }), react.createElement(Text/* default */.Z, null, title));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesProductCard_ServicesProductCard = (ServicesProductCard);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesProductCard/index.js


/***/ }),

/***/ 79648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ServicesWrapper_ServicesWrapper; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../modules/build/esm/components/ecommerce/ServicesGroup/index.js + 3 modules
var ServicesGroup = __webpack_require__(28946);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Grid/index.js + 2 modules
var Grid = __webpack_require__(8341);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.styles.js

var _templateObject;



var ServicesGrid = (0,styled_components_browser_esm["default"])(Grid/* default */.Z)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-gap: 8px;\n  grid-template-columns: minmax(0, 1fr);\n  ", " {\n    grid-template-columns: ", ";\n  }\n"])), (0,esm.getMediaQuery)('small'), function (props) {
  return "repeat(".concat(props.nCards || 1, ", 1fr)");
});
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.types.js

var ServicesWrapperPropTypes = {
  services: (0,prop_types.arrayOf)((0,prop_types.shape)({
    benefit: (0,prop_types.arrayOf)((0,prop_types.shape)({
      description: prop_types.string
    })),
    extraInfo: (0,prop_types.shape)({
      agreementText: prop_types.string,
      benefit: (0,prop_types.arrayOf)((0,prop_types.shape)({
        description: prop_types.string
      })),
      label: prop_types.string,
      labelBold: prop_types.string,
      title: prop_types.string,
      videoUrl: prop_types.string
    }),
    label: prop_types.string,
    labelBold: prop_types.string,
    period: (0,prop_types.shape)({
      options: (0,prop_types.arrayOf)((0,prop_types.shape)({
        checked: prop_types.bool,
        recommended: prop_types.bool,
        selectedOfferPrice: (0,prop_types.shape)({
          subtitle: prop_types.string,
          title: (0,prop_types.shape)({
            bold: prop_types.string,
            text: prop_types.string
          })
        }),
        title: prop_types.string,
        value: prop_types.number
      })),
      value: prop_types.number
    }),
    title: prop_types.string,
    videoUrl: prop_types.string
  })).isRequired
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/ServicesWrapper.js





var ServicesWrapper = function ServicesWrapper(props) {
  var services = props.services;
  return react.createElement(ServicesGrid, {
    "data-testid": "services-grid",
    nCards: services.length
  }, services.map(function (service) {
    return react.createElement(ServicesGroup/* default */.Z, {
      key: "services-group-".concat(service.key),
      service: service
    });
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var ServicesWrapper_ServicesWrapper = ((0,withLayoutProps/* default */.Z)(ServicesWrapper));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ServicesWrapper/index.js


/***/ }),

/***/ 644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareActions_ShareActions; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js + 2 modules
var CopyToClipboard = __webpack_require__(12241);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Checkbox/index.js + 2 modules
var Checkbox = __webpack_require__(18281);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Radio/index.js + 2 modules
var Radio = __webpack_require__(70715);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useShortenLink.js
var useShortenLink = __webpack_require__(15138);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/ProductLink.styles.js

var _templateObject;

var Grid = styled_components_browser_esm["default"].div(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: grid;\n  grid-template-columns: auto auto;\n\n  & label {\n    padding-top: 0;\n  }\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/hooks/setShortLink.js

var setShortLink = function setShortLink(shortenedLink, shortenType, setUrlToCopy) {
  (0,react.useEffect)(function () {
    if (shortenedLink) {
      sessionStorage.setItem(shortenType, shortenedLink);
      setUrlToCopy(shortenedLink);
    }
  }, [shortenedLink]);
};
/* harmony default export */ var hooks_setShortLink = (setShortLink);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/ProductLink.js












var ProductLink = function ProductLink(_ref) {
  var _shortenedConfigs$mag, _shortenedConfigs$one, _window2, _window2$location;
  var sectionUrl = _ref.sectionUrl,
    structure = _ref.structure;
  var shareUrlCookie = (0,esm/* getCookie */.ej)('toggle_shareurl_pmd_v2') || '';
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isShortUrl = _useState2[0],
    setIsShortUrl = _useState2[1];
  var _useState3 = (0,react.useState)('store'),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    typeUrl = _useState4[0],
    setTypeUrl = _useState4[1];
  var _useState5 = (0,react.useState)(sectionUrl.url),
    _useState6 = (0,slicedToArray/* default */.Z)(_useState5, 2),
    urlToCopy = _useState6[0],
    setUrlToCopy = _useState6[1];
  var isWindowNotUndefined = typeof window !== 'undefined';
  var shouldShowShortenRadios = (sectionUrl == null ? void 0 : sectionUrl.allowSuperAppLink) && shareUrlCookie.includes('app');
  var shouldShowShortenCheckbox = shareUrlCookie.includes('shorten') && typeUrl === 'store';
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config;
  var toShortenUrls = {
    desktop: "".concat(config.domain).concat(asPath),
    magaly: "".concat(config.domain).concat(asPath),
    onelink: "https://m.magazineluiza.com.br".concat(asPath == null ? void 0 : asPath.split(basePath).join(''))
  };
  var resetShortenSearch = function resetShortenSearch() {
    var _window$sessionStorag, _window$sessionStorag2;
    setUrlToCopy(sectionUrl.url);
    setTypeUrl('store');
    setIsShortUrl(false);
    (_window$sessionStorag = window.sessionStorage) == null ? void 0 : _window$sessionStorag.setItem('shorten_magaly', null);
    (_window$sessionStorag2 = window.sessionStorage) == null ? void 0 : _window$sessionStorag2.setItem('shorten_onelink', null);
  };
  var shortenedConfigs = {
    magaly: (0,useShortenLink/* default */.Z)('shortenlink-magaly', {
      link: toShortenUrls.magaly
    }),
    onelink: (0,useShortenLink/* default */.Z)('shortenlink-onelink', {
      addPartnerId: true,
      desktopLink: toShortenUrls.desktop,
      link: toShortenUrls.onelink
    })
  };
  hooks_setShortLink(shortenedConfigs == null ? void 0 : (_shortenedConfigs$mag = shortenedConfigs.magaly) == null ? void 0 : _shortenedConfigs$mag.shortLink, 'shorten_magaly', setUrlToCopy);
  hooks_setShortLink(shortenedConfigs == null ? void 0 : (_shortenedConfigs$one = shortenedConfigs.onelink) == null ? void 0 : _shortenedConfigs$one.shortLink, 'shorten_onelink', setUrlToCopy);
  (0,react.useEffect)(function () {
    sessionStorage.setItem('shorten_magaly', null);
    sessionStorage.setItem('shorten_onelink', null);
  }, []);
  (0,react.useEffect)(function () {
    var _window, _window$location;
    return isWindowNotUndefined && ((_window = window) == null ? void 0 : (_window$location = _window.location) == null ? void 0 : _window$location.href) && resetShortenSearch();
  }, [isWindowNotUndefined && ((_window2 = window) == null ? void 0 : (_window2$location = _window2.location) == null ? void 0 : _window2$location.href)]);
  (0,react.useEffect)(function () {
    var type;
    if (isShortUrl && typeUrl === 'store') type = 'magaly';
    if (typeUrl === 'app') type = 'onelink';
    if (type) {
      var url = sessionStorage.getItem("shorten_".concat(type));
      if (!url || url === 'null' || url === 'undefined') shortenedConfigs[type].handleShortenLink();else setUrlToCopy(url);
    } else {
      setUrlToCopy(sectionUrl.url);
    }
  }, [isShortUrl, typeUrl]);
  return react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionUrl.title), shouldShowShortenRadios && react.createElement(Grid, null, react.createElement(Radio/* default */.Z, {
    label: "Minha loja",
    value: "store",
    checked: typeUrl === 'store',
    onChange: function onChange(e) {
      return setTypeUrl(e.target.value);
    }
  }), react.createElement(Radio/* default */.Z, {
    label: "App do Magalu",
    value: "app",
    checked: typeUrl === 'app',
    onChange: function onChange(e) {
      return setTypeUrl(e.target.value);
    }
  })), react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(CopyToClipboard/* default */.Z, {
    value: urlToCopy
  })), shouldShowShortenCheckbox && react.createElement(Checkbox/* default */.Z, {
    checked: isShortUrl,
    onChange: function onChange(e) {
      setIsShortUrl(e.target.checked);
    },
    fontSize: 1,
    mb: 3
  }, "Link curto"));
};
 false ? 0 : void 0;
ProductLink.defaultProps = {
  sectionUrl: {
    allowSuperAppLink: false,
    title: 'Link do produto',
    url: '#'
  },
  structure: {}
};
ProductLink.ssr = false;
ProductLink.displayName = 'ProductLink';
/* harmony default export */ var ProductLink_ProductLink = (ProductLink);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/ProductLink/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var build_esm = __webpack_require__(34490);
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var stereo_ui_styles_build_esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/SharedBag.styles.js

var SharedBag_styles_templateObject;



var SharedBagButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(SharedBag_styles_templateObject || (SharedBag_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  font-size: ", "px;\n"])), function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('palette.background.white')(props);
}, function (props) {
  return (0,stereo_ui_styles_build_esm.themeGet)('fontSizes.0')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/SharedBag.js


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }








var SharedBag = function SharedBag(_ref) {
  var sectionSharedBag = _ref.sectionSharedBag,
    product = _ref.product,
    storeNumericId = _ref.storeNumericId,
    cookieDomain = _ref.cookieDomain;
  var _useSharedBag = (0,graphql_build_esm.useSharedBag)(),
    addToSharedBag = _useSharedBag.addToSharedBag;
  var PMD_SHAREDBAG = esm/* cookiesConstants.PMD_SHAREDBAG */.VD.PMD_SHAREDBAG;
  var showSectionSharedBag = (sectionSharedBag == null ? void 0 : sectionSharedBag.show) === 'true';
  var seller = product.seller.id;
  var sku = product.variationId;
  var sharedBagId = (0,esm/* getCookie */.ej)(PMD_SHAREDBAG);
  var createSharedBag = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      var _yield$addToSharedBag, sharedBagData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return addToSharedBag({
              seller: seller,
              sharedBagId: sharedBagId,
              sku: sku,
              storeNumericId: storeNumericId
            });
          case 2:
            _yield$addToSharedBag = _context.sent;
            sharedBagData = _yield$addToSharedBag.data;
            if (sharedBagData && typeof (sharedBagData == null ? void 0 : sharedBagData.id) === 'string') {
              (0,esm/* setCookie */.d8)({
                domain: cookieDomain,
                name: PMD_SHAREDBAG,
                value: sharedBagData.id
              });
              (0,esm/* routePush */.dY)({
                path: "".concat(sectionSharedBag.url, "/").concat(sharedBagData.id),
                spa: false
              });
            }
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createSharedBag() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!showSectionSharedBag) {
    return null;
  }
  return react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSharedBag.title), react.createElement(SharedBagButton, {
    color: "primary",
    "data-testid": "sharedbag-button",
    full: true,
    href: "#",
    mr: 3,
    onClick: function onClick() {
      createSharedBag();
    },
    rel: "noopener",
    size: "large",
    startIcon: react.createElement(build_esm/* Icon */.JO$, {
      name: "ShoppingBag",
      width: 32,
      height: 32
    }),
    target: "_blank",
    title: "ShoppingBag",
    variation: "outline"
  }, sectionSharedBag.buttonLabel));
};
 false ? 0 : void 0;
SharedBag.defaultProps = {
  cookieDomain: '',
  product: {
    seller: {
      id: ''
    },
    variationId: ''
  },
  sectionSharedBag: {
    buttonLabel: 'Adicionar na sacola pronta',
    show: 'false',
    title: 'Compartilhe produtos na sacola pronta',
    url: '#'
  },
  storeNumericId: ''
};
SharedBag.ssr = false;
SharedBag.displayName = 'SharedBag';
/* harmony default export */ var SharedBag_SharedBag = (SharedBag);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SharedBag/index.js

// EXTERNAL MODULE: ../../node_modules/react-qr-code/lib/index.js
var lib = __webpack_require__(38001);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Dialog/index.js + 1 modules
var Dialog = __webpack_require__(66762);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var publisher_build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/commons/isValidStaticProp.js
var isValidStaticProp = __webpack_require__(68909);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/SocialMedia.styles.js

var SocialMedia_styles_templateObject;


var SharedActionsIcon = (0,styled_components_browser_esm["default"])(build_esm/* Icon */.JO$)(SocialMedia_styles_templateObject || (SocialMedia_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/SocialMedia.js












var SocialMedia = function SocialMedia(_ref) {
  var sectionSocial = _ref.sectionSocial,
    sectionUrl = _ref.sectionUrl;
  var qrCodeRef = (0,react.useRef)(null);
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    openQRCodeModal = _useState2[0],
    setOpenQRCodeModal = _useState2[1];
  var _usePublisher = (0,publisher_build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var handleQRCodeDownload = function handleQRCodeDownload() {
    var svgData = new XMLSerializer().serializeToString(qrCodeRef.current);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var img = new Image();
    img.onload = function () {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      var pngFile = canvas.toDataURL('image/png');
      var downloadLink = document.createElement('a');
      downloadLink.download = 'QRCode';
      downloadLink.href = "".concat(pngFile);
      downloadLink.click();
      setOpenQRCodeModal(false);
    };
    img.src = "data:image/svg+xml;base64,".concat(btoa(svgData));
  };
  var handleClick = function handleClick(event, _ref2) {
    var eventType = _ref2.eventType,
      href = _ref2.href;
    if (href === '#') {
      event.preventDefault();
      setOpenQRCodeModal(true);
    }
    publish(eventType);
  };
  return react.createElement(Box/* default */.Z, {
    mb: 3
  }, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSocial.title), react.createElement(Flex/* default */.Z, null, Object.entries(sectionSocial.buttons).map(function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      entry = _ref4[0],
      _ref4$ = _ref4[1],
      href = _ref4$.href,
      _ref4$$name = _ref4$.name,
      name = _ref4$$name === void 0 ? '' : _ref4$$name,
      color = _ref4$.color,
      eventType = _ref4$.eventType,
      _ref4$$iconColor = _ref4$.iconColor,
      iconColor = _ref4$$iconColor === void 0 ? '#fff' : _ref4$$iconColor,
      customColor = _ref4$.customColor;
    return (0,isValidStaticProp/* default */.Z)(href) && react.createElement(Button/* default */.Z, {
      key: "".concat(entry, "-").concat(name),
      as: "a",
      title: name,
      centered: false,
      color: color,
      customColor: customColor,
      "data-testid": "share-actions-".concat(name.toLowerCase(), "-button"),
      disabled: false,
      full: false,
      href: href,
      target: "_blank",
      rel: "noopener",
      onClick: function onClick(event) {
        return handleClick(event, {
          eventType: eventType,
          href: href
        });
      },
      variation: "fill",
      size: "auto",
      height: "52px",
      width: "52px",
      mr: 3
    }, react.createElement(SharedActionsIcon, {
      name: name,
      color: iconColor,
      width: 32,
      height: 32
    }));
  })), react.createElement(Dialog/* default */.Z, {
    visible: openQRCodeModal,
    onClickOutside: function onClickOutside() {
      return setOpenQRCodeModal(false);
    },
    type: "alert",
    bg: "background.white",
    position: "center",
    showClose: true
  }, react.createElement(Text/* default */.Z, {
    mt: "2",
    textAlign: "center"
  }, react.createElement(lib/* default */.ZP, {
    "data-testid": "share-actions-modal-qrcode",
    ref: qrCodeRef,
    value: sectionUrl.url
  })), react.createElement(Button/* default */.Z, {
    "data-testid": "share-actions-btn-download-qrcode",
    onClick: handleQRCodeDownload,
    m: "10px 0 0",
    variation: "outline",
    full: true
  }, sectionUrl.downloadQRCode)));
};
 false ? 0 : void 0;
SocialMedia.defaultProps = {
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  sectionUrl: {
    downloadQRCode: 'Baixar QR code',
    title: 'Link do produto',
    url: '#'
  }
};
SocialMedia.ssr = false;
SocialMedia.displayName = 'SocialMedia';
/* harmony default export */ var SocialMedia_SocialMedia = (SocialMedia);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/components/SocialMedia/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/ShareActions.js








var ShareActions = function ShareActions(_ref) {
  var _channel$data$, _channel$data$$value, _structure$config;
  var data = _ref.data,
    StaticProps = _ref["static"],
    structure = _ref.structure;
  var channel = data.channel,
    product = data.product;
  var sectionSharedBag = StaticProps.sectionSharedBag,
    sectionSocial = StaticProps.sectionSocial,
    sectionUrl = StaticProps.sectionUrl;
  return react.createElement(Flex/* default */.Z, {
    flexDirection: "column"
  }, react.createElement(Text/* default */.Z, {
    fontSize: 2,
    fontWeight: "medium",
    mb: 3,
    mt: 2
  }, StaticProps.title), react.createElement(SharedBag_SharedBag, {
    sectionSharedBag: sectionSharedBag,
    product: product,
    storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
    cookieDomain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain
  }), react.createElement(ProductLink_ProductLink, {
    sectionUrl: sectionUrl,
    structure: structure
  }), react.createElement(SocialMedia_SocialMedia, {
    sectionUrl: sectionUrl,
    sectionSocial: sectionSocial
  }));
};
 false ? 0 : void 0;
ShareActions.defaultProps = {
  data: {
    channel: {}
  },
  "static": {
    sectionSharedBag: {
      buttonLabel: 'Adicionar na sacola pronta',
      show: 'false',
      title: 'Compartilhe produtos na sacola pronta',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    },
    sectionUrl: {
      downloadQRCode: 'Baixar QR code',
      title: 'Link do produto',
      url: '#'
    },
    title: 'Ferramentas do Divulgador'
  },
  structure: {}
};
ShareActions.ssr = false;
ShareActions.displayName = 'ShareActions';
/* harmony default export */ var ShareActions_ShareActions = ((0,withLayoutProps/* default */.Z)(ShareActions));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareActions/index.js


/***/ }),

/***/ 32620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ShareLinks_ShareLinks; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/hooks/useScrollLock.js

var useScrollLock = function useScrollLock(device, active) {
  (0,react.useEffect)(function () {
    if (device === 'desktop') document.body.style.overflowX = 'hidden';
    if (device === 'mobile' && active) document.body.style.overflow = 'hidden';
    return function () {
      document.body.style.overflowX = 'visible';
      document.body.style.overflow = 'visible';
    };
  }, [active]);
};
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var build_esm = __webpack_require__(55403);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/index.js + 24 modules
var atoms = __webpack_require__(87043);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/index.js
var stereo_ui_icons_build_esm = __webpack_require__(34490);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/ShareLinks.styles.js

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;




var CloseButton = (0,styled_components_browser_esm["default"])(atoms/* Button */.zx)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  border-radius: 100%;\n  height: 24px;\n  min-width: 24px;\n  padding: 0;\n"])));
var CloseButtonIcon = (0,styled_components_browser_esm["default"])(stereo_ui_icons_build_esm/* Icon */.JO$)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: #51585c !important;\n"])));
var Container = styled_components_browser_esm["default"].div(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: ", ";\n  display: flex;\n  max-height: 90%;\n  padding: 16px;\n  overflow-y: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: ", ";\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 3px;\n  }\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n  ", "\n"])), function (props) {
  return (0,build_esm.themeGet)('palette.background.white')(props);
}, function (props) {
  return (0,build_esm.themeGet)('palette.background.light')(props);
}, function (props) {
  return (0,build_esm.themeGet)('palette.primary.main')(props);
}, function (_ref) {
  var device = _ref.device;
  return device === 'mobile' && (0,styled_components_browser_esm.css)(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n      border-top-left-radius: 32px;\n      border-top-right-radius: 32px;\n      bottom: -90%;\n      left: 0;\n      position: fixed;\n      right: 0;\n      width: 100%;\n      align-items: flex-start;\n      transition: all 0.3s ease-out;\n    "])));
}, function (_ref2) {
  var device = _ref2.device;
  return device === 'desktop' && (0,styled_components_browser_esm.css)(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n      position: fixed;\n      width: 540px;\n      height: fit-content;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%) scale(0.95);\n      border-radius: 16px;\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n      background-color: ", ";\n      padding: 24px;\n      transition: opacity 0.5s ease, transform 0.5s ease;\n      opacity: 0;\n      pointer-events: none;\n    "])), function (props) {
    return (0,build_esm.themeGet)('palette.background.white')(props);
  });
}, function (_ref3) {
  var device = _ref3.device,
    active = _ref3.active;
  return device === 'desktop' && active && (0,styled_components_browser_esm.css)(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n      opacity: 1;\n      transform: translate(-50%, -50%) scale(1);\n      pointer-events: auto;\n    "])));
}, function (_ref4) {
  var active = _ref4.active;
  return active && (0,styled_components_browser_esm.css)(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n      z-index: 2;\n      bottom: 0;\n    "])));
});
var Content = (0,styled_components_browser_esm["default"])(atoms/* Flex */.kC)(_templateObject8 || (_templateObject8 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  @media (max-width: 768px) {\n    min-height: 70vh;\n  }\n"])));
var Description = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)(_templateObject9 || (_templateObject9 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  padding: ", "px 0px\n    ", "px;\n  line-height: ", "px;\n"])), (0,build_esm.themeGet)('fontSizes.2'), function (props) {
  return (0,build_esm.themeGet)('space.2')(props);
}, function (props) {
  return (0,build_esm.themeGet)('space.3')(props);
}, function (props) {
  return (0,build_esm.themeGet)('space.3')(props);
});
var ShareContainer = styled_components_browser_esm["default"].div(_templateObject10 || (_templateObject10 = (0,taggedTemplateLiteral/* default */.Z)(["\n  position: absolute;\n  z-index: ", ";\n"])), function (props) {
  return (0,build_esm.themeGet)('zIndices.3')(props);
});
var ShareOverlay = styled_components_browser_esm["default"].div(_templateObject11 || (_templateObject11 = (0,taggedTemplateLiteral/* default */.Z)(["\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  height: 100%;\n  transition: all 0.3s ease-out;\n  width: 100%;\n\n  ", "\n\n  ", "\n"])), function (_ref5) {
  var active = _ref5.active;
  return active && (0,styled_components_browser_esm.css)(_templateObject12 || (_templateObject12 = (0,taggedTemplateLiteral/* default */.Z)(["\n      bottom: 0;\n      left: 0;\n      position: fixed;\n      right: 0;\n      top: 0;\n      transition: all 0.3s ease-in;\n      z-index: 1;\n    "])));
}, function (_ref6) {
  var device = _ref6.device;
  return device === 'desktop' && (0,styled_components_browser_esm.css)(_templateObject13 || (_templateObject13 = (0,taggedTemplateLiteral/* default */.Z)(["\n      display: block;\n    "])));
});
var Title = (0,styled_components_browser_esm["default"])(atoms/* Text */.xv)(_templateObject14 || (_templateObject14 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-weight: 600;\n  font-size: ", "px;\n  padding: ", "px 0px;\n"])), (0,build_esm.themeGet)('fontSizes.5'), function (props) {
  return (0,build_esm.themeGet)('space.3')(props);
});
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var utils_build_esm = __webpack_require__(62624);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useShortenLink.js
var useShortenLink = __webpack_require__(15138);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/constants.js
var EventLinkType = {
  APP_MAGALU: 'app-magalu',
  INFLUENCIADOR_MAGALU: 'influenciador-magalu'
};
var SessionStorageItem = {
  MAGALY: 'shorten_magaly',
  ONELINK: 'shorten_onelink'
};
var ShortenLinkTypes = {
  MAGALY: 'shortenlink-magaly',
  ONELINK: 'shortenlink-onelink'
};
var TabDescription = {
  APP_MAGALU: 'Esse link de afiliado direciona o cliente para o app do Magalu, caso o cliente não tenha o app irá para sua loja no site Magazinevoce.',
  INFLUENCIADOR_MAGALU: 'Esse link direciona para sua loja no site Magazinevoce.',
  OFFER_MAGALU: 'Esse link de afiliado direciona o cliente para o app do Magalu, caso o cliente não tenha o app irá para o site do magazineluiza.com.br.'
};
var TabTitle = {
  APP_MAGALU: 'App Magalu',
  INFLUENCIADOR_MAGALU: 'Influenciador Magalu'
};
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/utils/getPromoterIdFromChannel.js
var getPromoterIdFromChannel = function getPromoterIdFromChannel(channel) {
  var _channel$data, _promoterChannel$valu, _promoterChannel$valu2;
  if ((channel == null ? void 0 : channel.name) !== 'parceiromagalu.com.br') return '';
  var promoterChannel = (_channel$data = channel.data) == null ? void 0 : _channel$data.find(function (item) {
    return item.name === 'store';
  });
  return (_promoterChannel$valu = promoterChannel == null ? void 0 : (_promoterChannel$valu2 = promoterChannel.value) == null ? void 0 : _promoterChannel$valu2.id) !== null && _promoterChannel$valu !== void 0 ? _promoterChannel$valu : '';
};
/* harmony default export */ var utils_getPromoterIdFromChannel = (getPromoterIdFromChannel);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/utils/getPromoterOfferPageLinks.js
var getPromoterOfferPageLinks = function getPromoterOfferPageLinks(_ref) {
  var asPath = _ref.asPath,
    basePath = _ref.basePath,
    promoterId = _ref.promoterId,
    sellerId = _ref.sellerId;
  var promoterOfferPageRoute = "".concat(asPath == null ? void 0 : asPath.split(basePath).join('').replace('/p/', '/divulgador/oferta/'));
  var mobileLink = "https://m.magazineluiza.com.br".concat(promoterOfferPageRoute, "?promoter_id=").concat(promoterId, "&partner_id=3440&seller_id=").concat(sellerId);
  var desktopLink = "https://magazineluiza.com.br".concat(promoterOfferPageRoute, "?promoter_id=").concat(promoterId, "&partner_id=3440&seller_id=").concat(sellerId);
  return {
    desktop: desktopLink,
    mobile: mobileLink
  };
};
/* harmony default export */ var utils_getPromoterOfferPageLinks = (getPromoterOfferPageLinks);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/utils/getShareableLinks.js


var getShareableLinks = function getShareableLinks(_ref) {
  var data = _ref.data,
    structure = _ref.structure,
    toggleSharePromoterOfferLink = _ref.toggleSharePromoterOfferLink;
  var _structure$asPath = structure.asPath,
    asPath = _structure$asPath === void 0 ? '' : _structure$asPath,
    _structure$basePath = structure.basePath,
    basePath = _structure$basePath === void 0 ? '' : _structure$basePath,
    _structure$config = structure.config,
    config = _structure$config === void 0 ? {} : _structure$config,
    canonicalPath = structure.canonicalPath,
    query = structure.query;
  var promoterId = utils_getPromoterIdFromChannel(data.channel);
  var shouldRedirectToPromoterOfferPage = !!toggleSharePromoterOfferLink && toggleSharePromoterOfferLink !== 'false';
  var promoterOfferPageLink = utils_getPromoterOfferPageLinks({
    asPath: asPath,
    basePath: basePath,
    promoterId: promoterId,
    sellerId: query == null ? void 0 : query.sellerId
  });
  var buildLink = function buildLink(base, path) {
    return "".concat(base).concat(path);
  };
  var desktopLink = shouldRedirectToPromoterOfferPage ? promoterOfferPageLink.desktop : buildLink('https://www.magazineluiza.com.br', canonicalPath.split(basePath).join(''));
  var link = shouldRedirectToPromoterOfferPage ? promoterOfferPageLink.mobile : buildLink('https://m.magazineluiza.com.br', canonicalPath.split(basePath).join(''));
  var influenciadorMagaluLink = buildLink(config.domain, canonicalPath);
  return {
    desktopLink: desktopLink,
    link: link,
    magaly: influenciadorMagaluLink
  };
};
/* harmony default export */ var utils_getShareableLinks = (getShareableLinks);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/hooks/useProductShortenLink.js






var isUrlInvalid = function isUrlInvalid(_ref) {
  var url = _ref.url,
    productId = _ref.productId,
    sku = _ref.sku;
  return !url || url === 'null' || url === 'undefined' || sku !== productId;
};
var shouldSkipShortenLink = function shouldSkipShortenLink(storageKey, toggleRemovePromoterOfferTabs) {
  return storageKey === SessionStorageItem.MAGALY && toggleRemovePromoterOfferTabs === true;
};
var getOnelinkConfig = function getOnelinkConfig(toggleSharePromoterOfferLink, linksToShare) {
  return toggleSharePromoterOfferLink === 'magaly' ? {
    params: {
      link: linksToShare == null ? void 0 : linksToShare.desktopLink
    },
    type: ShortenLinkTypes.MAGALY
  } : {
    params: {
      addPartnerId: true,
      desktopLink: linksToShare == null ? void 0 : linksToShare.desktopLink,
      link: linksToShare == null ? void 0 : linksToShare.link
    },
    type: ShortenLinkTypes.ONELINK
  };
};
var useProductShortenLink = function useProductShortenLink(_ref2) {
  var active = _ref2.active,
    data = _ref2.data,
    structure = _ref2.structure;
  var _useState = (0,react.useState)(''),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    oneLinkUrlToCopy = _useState2[0],
    setOneLinkUrlToCopy = _useState2[1];
  var _useState3 = (0,react.useState)(''),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    magalyUrlToCopy = _useState4[0],
    setMagalyUrlToCopy = _useState4[1];
  var _useCookies = (0,utils_build_esm/* useCookies */.fP)(),
    _useCookies$toggleSha = _useCookies.toggleSharePromoterOfferLink,
    toggleSharePromoterOfferLink = _useCookies$toggleSha === void 0 ? '' : _useCookies$toggleSha,
    _useCookies$toggleRem = _useCookies.toggleRemovePromoterOfferTabs,
    toggleRemovePromoterOfferTabs = _useCookies$toggleRem === void 0 ? '' : _useCookies$toggleRem;
  var _ref3 = structure || {},
    _ref3$route = _ref3.route,
    route = _ref3$route === void 0 ? {} : _ref3$route;
  var linksToShare = (0,react.useMemo)(function () {
    return utils_getShareableLinks({
      data: data,
      structure: structure,
      toggleSharePromoterOfferLink: toggleSharePromoterOfferLink
    });
  }, [data, structure, toggleSharePromoterOfferLink]);
  var magalyShortenLink = (0,useShortenLink/* default */.Z)(ShortenLinkTypes.MAGALY, {
    link: linksToShare == null ? void 0 : linksToShare.magaly
  });
  var onelinkConfig = getOnelinkConfig(toggleSharePromoterOfferLink, linksToShare);
  var onelinkShortenLink = (0,useShortenLink/* default */.Z)(onelinkConfig.type, onelinkConfig.params);
  var shortenedConfigs = (0,react.useMemo)(function () {
    return {
      magaly: magalyShortenLink,
      onelink: onelinkShortenLink
    };
  }, [magalyShortenLink, onelinkShortenLink]);
  var updateShortenedLink = function updateShortenedLink(_ref4) {
    var storageKey = _ref4.storageKey,
      setUrlToCopy = _ref4.setUrlToCopy,
      config = _ref4.config;
    var url = sessionStorage.getItem(storageKey);
    var sku = sessionStorage.getItem('sku');
    if (!isUrlInvalid({
      productId: route == null ? void 0 : route.productId,
      sku: sku,
      url: url
    })) {
      setUrlToCopy(url);
      return;
    }
    setUrlToCopy('');
    if (!shouldSkipShortenLink(storageKey, toggleRemovePromoterOfferTabs)) {
      config.handleShortenLink();
    }
  };
  var updateSessionStorage = function updateSessionStorage(_ref5) {
    var sessionStorageKey = _ref5.sessionStorageKey,
      link = _ref5.link,
      setUrlToCopy = _ref5.setUrlToCopy;
    sessionStorage.setItem(sessionStorageKey, link);
    sessionStorage.setItem('sku', route.productId);
    setUrlToCopy(link);
  };
  (0,react.useEffect)(function () {
    if (!active) return;
    updateShortenedLink({
      config: shortenedConfigs.onelink,
      setUrlToCopy: setOneLinkUrlToCopy,
      storageKey: SessionStorageItem.ONELINK
    });
    updateShortenedLink({
      config: shortenedConfigs.magaly,
      setUrlToCopy: setMagalyUrlToCopy,
      storageKey: SessionStorageItem.MAGALY
    });
  }, [structure, active]);
  (0,react.useEffect)(function () {
    if (shortenedConfigs.magaly.shortLink) {
      updateSessionStorage({
        link: shortenedConfigs.magaly.shortLink,
        sessionStorageKey: SessionStorageItem.MAGALY,
        setUrlToCopy: setMagalyUrlToCopy
      });
    }
    if (shortenedConfigs.onelink.shortLink) {
      updateSessionStorage({
        link: shortenedConfigs.onelink.shortLink,
        sessionStorageKey: SessionStorageItem.ONELINK,
        setUrlToCopy: setOneLinkUrlToCopy
      });
    }
  }, [shortenedConfigs.magaly.shortLink, shortenedConfigs.onelink.shortLink]);
  (0,react.useEffect)(function () {
    if (shortenedConfigs.magaly.isLoading) setMagalyUrlToCopy('');
    if (shortenedConfigs.onelink.isLoading) setOneLinkUrlToCopy('');
  }, [shortenedConfigs.magaly.isLoading, shortenedConfigs.onelink.isLoading]);
  return {
    magaly: {
      shortenLink: shortenedConfigs.magaly,
      urlToCopy: magalyUrlToCopy
    },
    oneLink: {
      shortenLink: shortenedConfigs.onelink,
      urlToCopy: oneLinkUrlToCopy
    }
  };
};
/* harmony default export */ var hooks_useProductShortenLink = (useProductShortenLink);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Text/index.js + 2 modules
var Text = __webpack_require__(63825);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-utils/build/esm/currencyFormatter/index.js
var currencyFormatter = __webpack_require__(93837);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Flex/index.js + 2 modules
var Flex = __webpack_require__(19527);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/ShareLinksProduct.styles.js

var ShareLinksProduct_styles_templateObject, ShareLinksProduct_styles_templateObject2, ShareLinksProduct_styles_templateObject3, ShareLinksProduct_styles_templateObject4, ShareLinksProduct_styles_templateObject5, ShareLinksProduct_styles_templateObject6;





var ContentInfo = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(ShareLinksProduct_styles_templateObject || (ShareLinksProduct_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  margin-bottom: 20px;\n  gap: 20px;\n"])));
var ContentProduct = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(ShareLinksProduct_styles_templateObject2 || (ShareLinksProduct_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  border: 1px solid #dddddd;\n  border-radius: 6px;\n\n  ", "\n"])), function (_ref) {
  var device = _ref.device;
  return device === 'desktop' && (0,styled_components_browser_esm.css)(ShareLinksProduct_styles_templateObject3 || (ShareLinksProduct_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n      margin-left: 40px;\n      margin-right: 40px;\n    "])));
});
var PriceContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(ShareLinksProduct_styles_templateObject4 || (ShareLinksProduct_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex: 1;\n  padding: 6px;\n  height: 50px;\n  border-radius: 0 0 6px 6px;\n  background-color: ", ";\n"])), function (props) {
  return (0,build_esm.themeGet)('palette.background.primary')(props);
});
var TextBestPrice = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(ShareLinksProduct_styles_templateObject5 || (ShareLinksProduct_styles_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: ", ";\n  color: ", ";\n"])), (0,build_esm.themeGet)('fontSizes.2'), (0,build_esm.themeGet)('fontWeights.bold'), (0,build_esm.themeGet)('palette.text.white'));
var TextPrice = (0,styled_components_browser_esm["default"])(Text/* default */.Z)(ShareLinksProduct_styles_templateObject6 || (ShareLinksProduct_styles_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n  font-size: ", "px;\n  font-weight: ", ";\n  margin-bottom: ", "px;\n  color: ", ";\n  text-decoration: line-through;\n"])), (0,build_esm.themeGet)('fontSizes.0'), (0,build_esm.themeGet)('fontWeights.regular'), (0,build_esm.themeGet)('space.1'), (0,build_esm.themeGet)('palette.text.white'));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/ShareLinksProduct.js








var ShareLinksProduct = function ShareLinksProduct(_ref) {
  var _product$image;
  var description = _ref.description,
    data = _ref.data,
    device = _ref.device;
  var product = data.product;
  var _ref2 = (data == null ? void 0 : data.product) || {},
    productPrice = _ref2.price;
  var _ref3 = productPrice || {},
    bestPrice = _ref3.bestPrice,
    price = _ref3.price;
  return react.createElement(ContentInfo, {
    "data-testid": "share-links-product"
  }, description && react.createElement(Text/* default */.Z, {
    as: "p",
    lineHeight: 1.2,
    height: "48px"
  }, description), react.createElement(Text/* default */.Z, {
    as: "p",
    lineHeight: 1.2,
    paddingTop: 2
  }, "Pr\xE9-visualiza\xE7\xE3o:"), react.createElement(ContentProduct, {
    device: device
  }, react.createElement(Box/* default */.Z, {
    p: 3
  }, react.createElement(atoms/* Image */.Ee, {
    borderRadius: "10px",
    src: product == null ? void 0 : (_product$image = product.image) == null ? void 0 : _product$image.replace('{w}x{h}', '300x160'),
    alt: product == null ? void 0 : product.title,
    style: {
      maxHeight: '160px'
    }
  })), react.createElement(PriceContainer, null, react.createElement(TextPrice, null, (0,currencyFormatter/* default */.Z)({
    value: price
  })), react.createElement(TextBestPrice, {
    fontSize: 1,
    fontWeight: "medium",
    color: "white"
  }, (0,currencyFormatter/* default */.Z)({
    value: bestPrice
  })))));
};
 false ? 0 : void 0;
ShareLinksProduct.defaultProps = {
  data: {},
  description: '',
  device: 'desktop'
};
/* harmony default export */ var ShareLinksProduct_ShareLinksProduct = ((0,withLayoutProps/* default */.Z)(ShareLinksProduct));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksProduct/index.js

// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/CopyToClipboard/index.js + 2 modules
var CopyToClipboard = __webpack_require__(12241);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/hooks/useShareLinksEvents.js

var useShareLinksEvents = function useShareLinksEvents(_ref) {
  var structure = _ref.structure,
    isDesktop = _ref.isDesktop;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var productName = isDesktop ? structure == null ? void 0 : structure.route.slug : structure == null ? void 0 : structure.route.productSlug;
  var productId = structure == null ? void 0 : structure.route.productId;
  var handleCopyLinkEvent = function handleCopyLinkEvent(_ref2) {
    var shareAction = _ref2.shareAction,
      linkType = _ref2.linkType;
    return publish('pmd:sharelinks:share:product:click', {
      linkType: linkType,
      pageType: structure == null ? void 0 : structure.name,
      productId: productId,
      productName: productName,
      shareAction: shareAction
    });
  };
  var handleAddToReadyBagEvent = function handleAddToReadyBagEvent() {
    return publish('pmd:sharelinks:add:ready:bag:click', {
      productId: productId,
      productName: productName
    });
  };
  return {
    handleAddToReadyBagEvent: handleAddToReadyBagEvent,
    handleCopyLinkEvent: handleCopyLinkEvent
  };
};
/* harmony default export */ var hooks_useShareLinksEvents = (useShareLinksEvents);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../modules/build/esm/commons/isValidStaticProp.js
var isValidStaticProp = __webpack_require__(68909);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Button/index.js + 2 modules
var Button = __webpack_require__(60861);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/SocialMedia.styles.js

var SocialMedia_styles_templateObject, SocialMedia_styles_templateObject2, SocialMedia_styles_templateObject3, SocialMedia_styles_templateObject4;





var SharedActionsIcon = (0,styled_components_browser_esm["default"])(stereo_ui_icons_build_esm/* Icon */.JO$)(SocialMedia_styles_templateObject || (SocialMedia_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var SocialMediaButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(SocialMedia_styles_templateObject2 || (SocialMedia_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 44px;\n  min-width: 0;\n  border-radius: 100%;\n  background-color: ", " !important;\n"])), function (_ref2) {
  var color = _ref2.color;
  return color;
});
var SocialMediaContainerButtons = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(SocialMedia_styles_templateObject3 || (SocialMedia_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 86px;\n"])));
var SocialMediaContent = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(SocialMedia_styles_templateObject4 || (SocialMedia_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  align-items: center;\n  gap: 20px;\n  overflow-x: auto;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/SocialMedia.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }







var SocialMedia = function SocialMedia(_ref) {
  var sectionSocial = _ref.sectionSocial,
    device = _ref.device,
    urlToCopy = _ref.urlToCopy,
    linkType = _ref.linkType,
    handleCopyLinkEvent = _ref.handleCopyLinkEvent;
  var _useState = (0,react.useState)('Copiar link'),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    copyButtonText = _useState2[0],
    setCopyButtonText = _useState2[1];
  var _useState3 = (0,react.useState)(false),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    isCopyButtonDisabled = _useState4[0],
    setIsCopyButtonDisabled = _useState4[1];
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var copyTimeoutRef = (0,react.useRef)(null);
  var isDesktop = device === 'desktop';
  var handleShareSocial = function handleShareSocial(eventType, href) {
    window.open(href, '_blank', 'noopener,noreferrer');
    publish("".concat(eventType, ":socialshare:click"));
    handleCopyLinkEvent({
      linkType: linkType,
      shareAction: eventType
    });
  };
  var handleCopy = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!isCopyButtonDisabled) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            handleCopyLinkEvent({
              linkType: linkType,
              shareAction: 'copiar-link'
            });
            _context.next = 5;
            return navigator.clipboard.writeText(urlToCopy);
          case 5:
            setCopyButtonText('Link Copiado!');
            setIsCopyButtonDisabled(true);
            if (copyTimeoutRef.current) {
              clearTimeout(copyTimeoutRef.current);
            }
            copyTimeoutRef.current = setTimeout(function () {
              setCopyButtonText('Copiar link');
              setIsCopyButtonDisabled(false);
              copyTimeoutRef.current = null;
            }, 2000);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleCopy() {
      return _ref2.apply(this, arguments);
    };
  }();
  (0,react.useEffect)(function () {
    return function () {
      if (copyTimeoutRef.current) {
        clearTimeout(copyTimeoutRef.current);
      }
    };
  }, []);
  return react.createElement(Box/* default */.Z, {
    "data-testid": "share-links-social-media"
  }, react.createElement(Text/* default */.Z, {
    as: "p",
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, sectionSocial.title), react.createElement(SocialMediaContent, null, !isDesktop && react.createElement(SocialMediaContainerButtons, null, react.createElement(SocialMediaButton, {
    "data-testid": "mobile-copy-link-button",
    color: "#D3DADD",
    onClick: handleCopy,
    disabled: isCopyButtonDisabled,
    "aria-label": copyButtonText
  }, react.createElement(SharedActionsIcon, {
    name: "Link",
    color: "#1E2428",
    width: 24,
    height: 24
  })), react.createElement(Text/* default */.Z, {
    "data-testid": "mobile-copy-link-button-text",
    fontSize: 1,
    fontWeight: "regular",
    mb: 3,
    mt: 2
  }, copyButtonText)), Object.entries((sectionSocial == null ? void 0 : sectionSocial.buttons) || {}).map(function (_ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
      entry = _ref4[0],
      _ref4$ = _ref4[1],
      href = _ref4$.href,
      _ref4$$name = _ref4$.name,
      name = _ref4$$name === void 0 ? '' : _ref4$$name,
      color = _ref4$.color,
      eventType = _ref4$.eventType,
      _ref4$$iconColor = _ref4$.iconColor,
      iconColor = _ref4$$iconColor === void 0 ? '#fff' : _ref4$$iconColor;
    return (0,isValidStaticProp/* default */.Z)(href) && react.createElement(SocialMediaContainerButtons, {
      key: "".concat(entry, "-").concat(name)
    }, react.createElement(SocialMediaButton, {
      "data-testid": "share-socialmedia-".concat(name.toLowerCase(), "-button"),
      color: color,
      "aria-label": "Compartilhar no ".concat(name),
      onClick: function onClick(e) {
        e.preventDefault();
        handleShareSocial(eventType, "".concat(href).concat(urlToCopy));
      }
    }, react.createElement(SharedActionsIcon, {
      name: name,
      color: iconColor,
      width: 24,
      height: 24
    })), react.createElement(Text/* default */.Z, {
      fontSize: 1,
      fontWeight: "regular",
      mb: 3,
      mt: 2
    }, name));
  })));
};
 false ? 0 : void 0;
SocialMedia.defaultProps = {
  device: 'mobile',
  sectionSocial: {
    title: 'Compartilhe nas redes sociais'
  },
  urlToCopy: ''
};
SocialMedia.ssr = false;
SocialMedia.displayName = 'SocialMedia';
/* harmony default export */ var SocialMedia_SocialMedia = (SocialMedia);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SocialMedia/index.js

// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/SharedBag.styles.js

var SharedBag_styles_templateObject;



var SharedBagButton = (0,styled_components_browser_esm["default"])(Button/* default */.Z)(SharedBag_styles_templateObject || (SharedBag_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background-color: ", ";\n  font-size: ", "px;\n  margin: 0 auto;\n"])), function (props) {
  return (0,build_esm.themeGet)('palette.background.white')(props);
}, function (props) {
  return (0,build_esm.themeGet)('fontSizes.2')(props);
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/SharedBag.js


function SharedBag_regeneratorRuntime() { "use strict"; SharedBag_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }






var SharedBag = function SharedBag(_ref) {
  var sectionSharedBag = _ref.sectionSharedBag,
    product = _ref.product,
    storeNumericId = _ref.storeNumericId,
    cookieDomain = _ref.cookieDomain,
    onAddToReadyBagEvent = _ref.onAddToReadyBagEvent;
  var _useSharedBag = (0,graphql_build_esm.useSharedBag)(),
    addToSharedBag = _useSharedBag.addToSharedBag;
  var PMD_SHAREDBAG = utils_build_esm/* cookiesConstants.PMD_SHAREDBAG */.VD.PMD_SHAREDBAG;
  var showSectionSharedBag = (sectionSharedBag == null ? void 0 : sectionSharedBag.show) === 'true';
  var seller = product.seller.id;
  var sku = product.variationId;
  var sharedBagId = (0,utils_build_esm/* getCookie */.ej)(PMD_SHAREDBAG);
  var createSharedBag = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(SharedBag_regeneratorRuntime().mark(function _callee() {
      var _yield$addToSharedBag, sharedBagData;
      return SharedBag_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            onAddToReadyBagEvent();
            _context.next = 3;
            return addToSharedBag({
              seller: seller,
              sharedBagId: sharedBagId,
              sku: sku,
              storeNumericId: storeNumericId
            });
          case 3:
            _yield$addToSharedBag = _context.sent;
            sharedBagData = _yield$addToSharedBag.data;
            if (sharedBagData && typeof (sharedBagData == null ? void 0 : sharedBagData.id) === 'string') {
              (0,utils_build_esm/* setCookie */.d8)({
                domain: cookieDomain,
                name: PMD_SHAREDBAG,
                value: sharedBagData.id
              });
              (0,utils_build_esm/* routePush */.dY)({
                path: "".concat(sectionSharedBag.url, "/").concat(sharedBagData.id),
                spa: false
              });
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function createSharedBag() {
      return _ref2.apply(this, arguments);
    };
  }();
  if (!showSectionSharedBag) return null;
  return react.createElement(SharedBagButton, {
    "data-testid": "sharedbag-button",
    full: true,
    href: "#",
    onClick: createSharedBag,
    rel: "noopener",
    size: "small",
    variation: "outline",
    target: "_blank",
    uppercase: false,
    title: "ShoppingBag",
    startIcon: react.createElement(stereo_ui_icons_build_esm/* Icon */.JO$, {
      name: "ShoppingBag",
      width: 24,
      height: 24
    })
  }, sectionSharedBag.buttonLabel);
};
 false ? 0 : void 0;
SharedBag.defaultProps = {
  cookieDomain: '',
  onAddToReadyBagEvent: null,
  product: {
    seller: {
      id: ''
    },
    variationId: ''
  },
  sectionSharedBag: {
    buttonLabel: 'Adicionar na sacola pronta',
    show: 'false',
    title: 'Compartilhe produtos na sacola pronta',
    url: '#'
  },
  storeNumericId: ''
};
SharedBag.ssr = false;
SharedBag.displayName = 'SharedBag';
/* harmony default export */ var SharedBag_SharedBag = (SharedBag);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/SharedBag/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/ShareLinksSkeleton.styles.js

var ShareLinksSkeleton_styles_templateObject, ShareLinksSkeleton_styles_templateObject2, ShareLinksSkeleton_styles_templateObject3, ShareLinksSkeleton_styles_templateObject4;


var variations = {
  circular: (0,styled_components_browser_esm.css)(ShareLinksSkeleton_styles_templateObject || (ShareLinksSkeleton_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-radius: ", ";\n  "])), (0,build_esm.themeGet)('radii.circle')),
  rectangular: (0,styled_components_browser_esm.css)(ShareLinksSkeleton_styles_templateObject2 || (ShareLinksSkeleton_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    border-radius: ", ";\n  "])), (0,build_esm.themeGet)('radii.default')),
  text: (0,styled_components_browser_esm.css)(ShareLinksSkeleton_styles_templateObject3 || (ShareLinksSkeleton_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n    height: 1em;\n    border-radius: ", ";\n  "])), (0,build_esm.themeGet)('radii.small'))
};
var ShareLinksSkeleton_styles_Container = styled_components_browser_esm["default"].div(ShareLinksSkeleton_styles_templateObject4 || (ShareLinksSkeleton_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: ", ";\n  height: ", ";\n\n  background: linear-gradient(\n      to right,\n      transparent,\n      rgba(255, 255, 255, 0.5) 50%,\n      transparent 80%\n    ),\n    ", ";\n  background-repeat: repeat-y;\n  background-size: 50px 500px;\n  background-position: 0 0;\n  animation: shine 1s infinite;\n  ", "\n  @keyframes shine {\n    to {\n      background-position: 100% 0, 0 0;\n    }\n  }\n"])), function (props) {
  return props.width || '120px';
}, function (props) {
  return props.height;
}, (0,build_esm.themeGet)('palette.background.whisper'), function (props) {
  return variations[props.variation];
});
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/ShareLinksSkeleton.js



var ShareLinksSkeleton = function ShareLinksSkeleton(_ref) {
  var width = _ref.width,
    height = _ref.height,
    variation = _ref.variation;
  return react.createElement(ShareLinksSkeleton_styles_Container, {
    "data-testid": "share-links-skeleton",
    width: width,
    height: height,
    variation: variation
  });
};
 false ? 0 : void 0;
ShareLinksSkeleton.defaultProps = {
  height: '32px',
  variation: 'rectangular'
};
/* harmony default export */ var ShareLinksSkeleton_ShareLinksSkeleton = (ShareLinksSkeleton);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksSkeleton/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActions.styles.js

var ShareLinksActions_styles_templateObject;


var ShareLinksActions_styles_ContentInfo = (0,styled_components_browser_esm["default"])(Flex/* default */.Z)(ShareLinksActions_styles_templateObject || (ShareLinksActions_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  flex-direction: column;\n  padding-bottom: 16px;\n  gap: 20px;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActionsSkeleton.js





var ShareLinksActionsSkeleton = function ShareLinksActionsSkeleton(_ref) {
  var isDesktop = _ref.isDesktop;
  return react.createElement(ShareLinksActions_styles_ContentInfo, {
    "data-testid": "share-links-actions"
  }, isDesktop && react.createElement(react.Fragment, null, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "100%",
    variation: "text"
  }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "100%",
    height: "52px",
    variation: "rectangular"
  })), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "100%",
    variation: "text"
  }), react.createElement(Flex/* default */.Z, {
    justifyContent: "flex-start",
    gap: "20px"
  }, react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    alignItems: "center",
    gap: "8px"
  }, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "44px",
    height: "44px",
    variation: "circular"
  }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "60px",
    variation: "text"
  })), react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    alignItems: "center",
    gap: "8px"
  }, react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "44px",
    height: "44px",
    variation: "circular"
  }), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "60px",
    variation: "text"
  }))), react.createElement(ShareLinksSkeleton_ShareLinksSkeleton, {
    width: "100%",
    height: "32px",
    variation: "rectangular"
  }));
};
 false ? 0 : void 0;
/* harmony default export */ var ShareLinksActions_ShareLinksActionsSkeleton = (ShareLinksActionsSkeleton);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/icons/index.js
var icons = __webpack_require__(42673);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActionsError.js






var ShareLinksActionsError = function ShareLinksActionsError(_ref) {
  var errorStatus = _ref.errorStatus;
  return errorStatus === 401 ? react.createElement(Flex/* default */.Z, {
    flexDirection: "column",
    alignItems: "center",
    gap: "10px"
  }, react.createElement(Text/* default */.Z, {
    color: "error.text",
    lineHeight: "1.2"
  }, "Ops! Parece que voc\xEA precisa fazer login no admin novamente para continuar."), react.createElement(Button/* default */.Z, {
    as: "a",
    variation: "outline",
    href: "/login",
    target: "_blank",
    rel: "noopener noreferrer",
    size: "small",
    endIcon: react.createElement(icons/* OpenLink */.QiM, {
      width: 20,
      height: 20
    }),
    full: true
  }, "Ir para o login")) : react.createElement(Text/* default */.Z, {
    color: "error.text",
    lineHeight: "1.2"
  }, "Poxa! Algo deu errado. Por favor, espere um pouquinho e tente de novo.");
};
/* harmony default export */ var ShareLinksActions_ShareLinksActionsError = (ShareLinksActionsError);
 false ? 0 : void 0;
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/ShareLinksActions.js












var ShareLinksContent = function ShareLinksContent(_ref) {
  var _channel$data$, _channel$data$$value, _structure$config;
  var data = _ref.data,
    linkType = _ref.linkType,
    structure = _ref.structure,
    shortenLink = _ref.shortenLink,
    urlToCopy = _ref.urlToCopy,
    staticProps = _ref.staticProps;
  var channel = data.channel,
    product = data.product;
  var _ref2 = staticProps || {},
    device = _ref2.device,
    sectionSharedBag = _ref2.sectionSharedBag,
    sectionSocial = _ref2.sectionSocial;
  var isDesktop = device === 'desktop';
  var _useShareLinksEvents = hooks_useShareLinksEvents({
      isDesktop: isDesktop,
      structure: structure
    }),
    handleAddToReadyBagEvent = _useShareLinksEvents.handleAddToReadyBagEvent,
    handleCopyLinkEvent = _useShareLinksEvents.handleCopyLinkEvent;
  if (shortenLink.isLoading) {
    return react.createElement(ShareLinksActions_ShareLinksActionsSkeleton, {
      isDesktop: isDesktop
    });
  }
  if (shortenLink.hasError) {
    return react.createElement(ShareLinksActions_ShareLinksActionsError, {
      errorStatus: shortenLink.error.status
    });
  }
  return react.createElement(ShareLinksActions_styles_ContentInfo, {
    "data-testid": "share-links-actions"
  }, isDesktop && react.createElement(Box/* default */.Z, null, react.createElement(Text/* default */.Z, {
    fontSize: 1,
    fontWeight: "regular",
    mb: 2
  }, "Link do produto"), react.createElement(Box/* default */.Z, {
    onClick: function onClick() {
      return handleCopyLinkEvent({
        linkType: linkType,
        shareAction: 'copiar-link'
      });
    },
    "data-testid": "desk-copy-link-button"
  }, react.createElement(CopyToClipboard/* default */.Z, {
    value: urlToCopy
  }))), react.createElement(SocialMedia_SocialMedia, {
    device: device,
    linkType: linkType,
    handleCopyLinkEvent: handleCopyLinkEvent,
    sectionSocial: sectionSocial,
    urlToCopy: urlToCopy
  }), react.createElement(SharedBag_SharedBag, {
    sectionSharedBag: sectionSharedBag,
    product: product,
    storeNumericId: channel == null ? void 0 : (_channel$data$ = channel.data[1]) == null ? void 0 : (_channel$data$$value = _channel$data$.value) == null ? void 0 : _channel$data$$value.id,
    cookieDomain: structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : _structure$config.cookieDomain,
    onAddToReadyBagEvent: handleAddToReadyBagEvent
  }));
};
 false ? 0 : void 0;
ShareLinksContent.defaultProps = {
  data: {},
  structure: {}
};
/* harmony default export */ var ShareLinksActions = ((0,withLayoutProps/* default */.Z)(ShareLinksContent));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksActions/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/Tabs/Tabs.styles.js

var Tabs_styles_templateObject, Tabs_styles_templateObject2, Tabs_styles_templateObject3, Tabs_styles_templateObject4;



var Tab = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Tabs_styles_templateObject || (Tabs_styles_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding: 10px 20px;\n  border-bottom: ", ";\n  color: ", ";\n  font-size: ", "px;\n  text-align: center;\n  @media (min-width: 1024px) {\n    width: 247.5px;\n    font-size: ", "px;\n  }\n"])), function (props) {
  return props.isActive ? '2px solid #0086FF' : '2px solid transparent';
}, function (props) {
  return props.isActive ? (0,build_esm.themeGet)('palette.text.primary') : (0,build_esm.themeGet)('palette.text.base');
}, (0,build_esm.themeGet)('fontSizes.2'), (0,build_esm.themeGet)('fontSizes.3'));
var TabContent = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Tabs_styles_templateObject2 || (Tabs_styles_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  padding-top: ", "px;\n"])), (0,build_esm.themeGet)('space.3'));
var TabList = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Tabs_styles_templateObject3 || (Tabs_styles_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  cursor: pointer;\n"])));
var TabsContainer = (0,styled_components_browser_esm["default"])(Box/* default */.Z)(Tabs_styles_templateObject4 || (Tabs_styles_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n  display: flex;\n  flex-direction: column;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/Tabs/Tabs.js




var Tabs = function Tabs(_ref) {
  var _tabs$activeTab;
  var tabs = _ref.tabs;
  var _useState = (0,react.useState)(0),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  if (!tabs) {
    return null;
  }
  return react.createElement(TabsContainer, null, react.createElement(TabList, null, tabs.map(function (tab, index) {
    return react.createElement(Tab, {
      key: tab.label,
      role: "tab",
      onClick: function onClick() {
        return setActiveTab(index);
      },
      isActive: activeTab === index,
      tabIndex: 0
    }, tab.label);
  })), react.createElement(TabContent, null, ((_tabs$activeTab = tabs[activeTab]) == null ? void 0 : _tabs$activeTab.content) || null));
};
 false ? 0 : void 0;
/* harmony default export */ var Tabs_Tabs = (Tabs);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/Tabs/index.js

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/hooks/useShareActionsTabsContent.js


var _excluded = ["data", "oneLink", "magaly"];





var useShareActionsTabsContent = function useShareActionsTabsContent(_ref) {
  var data = _ref.data,
    oneLink = _ref.oneLink,
    magaly = _ref.magaly,
    props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);
  var _useCookies = (0,utils_build_esm/* useCookies */.fP)(),
    _useCookies$toggleSha = _useCookies.toggleSharePromoterOfferLink,
    toggleSharePromoterOfferLink = _useCookies$toggleSha === void 0 ? '' : _useCookies$toggleSha;
  var appMagaluDescription = !!toggleSharePromoterOfferLink && toggleSharePromoterOfferLink !== 'false' ? TabDescription.OFFER_MAGALU : TabDescription.APP_MAGALU;
  var getShortenLink = function getShortenLink(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? oneLink.shortenLink : magaly.shortenLink;
  };
  var getUrlToCopy = function getUrlToCopy(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? oneLink.urlToCopy : magaly.urlToCopy;
  };
  var getLinkType = function getLinkType(shortenLinkType) {
    return shortenLinkType === ShortenLinkTypes.ONELINK ? EventLinkType.APP_MAGALU : EventLinkType.INFLUENCIADOR_MAGALU;
  };
  var getTabContent = function getTabContent(description, shortenLinkType) {
    return react.createElement(react.Fragment, null, react.createElement(ShareLinksProduct_ShareLinksProduct, {
      data: data,
      device: props.staticProps.device || 'desktop',
      description: description
    }), react.createElement(ShareLinksActions, (0,esm_extends/* default */.Z)({
      data: data,
      linkType: getLinkType(shortenLinkType),
      shortenLink: getShortenLink(shortenLinkType),
      urlToCopy: getUrlToCopy(shortenLinkType)
    }, props)));
  };
  return [{
    content: getTabContent(appMagaluDescription, ShortenLinkTypes.ONELINK),
    label: TabTitle.APP_MAGALU
  }, {
    content: getTabContent(TabDescription.INFLUENCIADOR_MAGALU, ShortenLinkTypes.MAGALY),
    label: TabTitle.INFLUENCIADOR_MAGALU
  }];
};
/* harmony default export */ var hooks_useShareActionsTabsContent = (useShareActionsTabsContent);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksModalContent/ShareLinksModalContent.js









var ShareLinksModalContent = function ShareLinksModalContent(_ref) {
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref.staticProps,
    oneLink = _ref.oneLink,
    magaly = _ref.magaly,
    isOpen = _ref.isOpen;
  var _useCookies = (0,utils_build_esm/* useCookies */.fP)(),
    toggleRemovePromoterOfferTabs = _useCookies.toggleRemovePromoterOfferTabs;
  var tabs = hooks_useShareActionsTabsContent({
    data: data,
    isOpen: isOpen,
    magaly: magaly,
    oneLink: oneLink,
    staticProps: staticProps,
    structure: structure
  });
  if (toggleRemovePromoterOfferTabs) {
    return react.createElement(react.Fragment, null, react.createElement(Title, {
      as: "h3",
      fontSize: 5,
      fontWeight: "bold",
      paddingTop: 1,
      color: "text.base"
    }, "Compartilhe e ganhe!"), react.createElement(Description, {
      as: "p",
      fontSize: 3,
      fontWeight: "bold",
      color: "Description.dark"
    }, "Copie seu link e compartilhe com seus clientes, com ele voc\xEA garante sua comiss\xE3o seja no app ou site do Magalu."), react.createElement(ShareLinksProduct_ShareLinksProduct, {
      data: data,
      device: structure.device || 'desktop'
    }), react.createElement(ShareLinksActions, {
      data: data,
      linkType: EventLinkType.APP_MAGALU,
      shortenLink: oneLink.shortenLink,
      urlToCopy: oneLink.urlToCopy,
      structure: structure,
      staticProps: staticProps
    }));
  }
  return react.createElement(react.Fragment, null, react.createElement(Title, {
    as: "h3",
    fontSize: 5,
    fontWeight: "bold",
    paddingBottom: 4,
    paddingTop: 1,
    color: "text.base"
  }, "Gerar link afiliado"), react.createElement(Description, {
    as: "p",
    fontSize: 3,
    fontWeight: "bold",
    color: "Description.dark",
    lineHeight: 2,
    paddingY: 2
  }, "Escolha a forma de compartilhar seu link de afiliado e envie para seu p\xFAblico."), react.createElement(Tabs_Tabs, {
    tabs: tabs
  }));
};
 false ? 0 : void 0;
ShareLinksModalContent.defaultProps = {
  data: {},
  structure: {}
};
/* harmony default export */ var ShareLinksModalContent_ShareLinksModalContent = (ShareLinksModalContent);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/components/ShareLinksModalContent/index.js

;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/ShareLinks.js









var ShareLinks = function ShareLinks(_ref) {
  var data = _ref.data,
    staticProps = _ref["static"],
    structure = _ref.structure;
  var _staticProps$device = staticProps.device,
    device = _staticProps$device === void 0 ? 'desktop' : _staticProps$device;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe;
  var _useState = (0,react.useState)(false),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  useScrollLock(device, isOpen);
  var onCloseShareActive = function onCloseShareActive() {
    return setIsOpen(false);
  };
  (0,react.useEffect)(function () {
    subscribe('sharelinksbutton:click', function () {
      return setIsOpen(true);
    });
  }, [subscribe]);
  var _useProductShortenLin = hooks_useProductShortenLink({
      active: isOpen,
      data: data,
      structure: structure
    }),
    oneLink = _useProductShortenLin.oneLink,
    magaly = _useProductShortenLin.magaly;
  if (!isOpen) {
    return null;
  }
  return react.createElement(ShareContainer, {
    "data-testid": "share-links"
  }, react.createElement(Container, {
    active: isOpen,
    device: device,
    "data-testid": "share-links-content"
  }, react.createElement(CloseButton, {
    "data-testid": "btn-close-modal",
    name: "Close",
    onClick: onCloseShareActive,
    color: "none",
    "aria-label": "fechar o modal"
  }, react.createElement(CloseButtonIcon, {
    name: "Close"
  })), react.createElement(Content, null, react.createElement(ShareLinksModalContent_ShareLinksModalContent, {
    data: data,
    structure: structure,
    staticProps: staticProps,
    oneLink: oneLink,
    magaly: magaly,
    isOpen: isOpen
  }))), react.createElement(ShareOverlay, {
    "data-testid": "share-links-overlay",
    device: device,
    active: isOpen,
    onClick: onCloseShareActive
  }));
};
 false ? 0 : void 0;
ShareLinks.defaultProps = {
  data: {},
  "static": {
    device: 'desktop',
    sectionSharedBag: {
      buttonLabel: 'Adicionar à Sacola Pronta',
      show: 'false',
      url: '#'
    },
    sectionSocial: {
      title: 'Compartilhe nas redes sociais'
    }
  },
  structure: {}
};
ShareLinks.ssr = false;
ShareLinks.displayName = 'ShareLinks';
ShareLinks.dataSource = {
  product: {
    query: 'ProductQuery'
  }
};
/* harmony default export */ var ShareLinks_ShareLinks = ((0,withLayoutProps/* default */.Z)(ShareLinks));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/ShareLinks/index.js


/***/ })

}]);